export function ViewLabelwithData({ title = "", value = "" }) {
  return (
    <div className=" w-full">
      <h2 className=" text-xs">{`${title} `} :</h2>
      <p className="  font-medium text-sm">{value || "-"}</p>
    </div>
  );
}

export function ViewLabelwithDataBg({ title = "", value = "" }) {
  return (
    <div className="my-3 text-left">
      <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">{title}</p>
      <p className="text-xs text-[#6E6985] font-semibold text-main-title bg-[#FDFAFF] py-3 pl-8">
        {value || "-"}
      </p>
    </div>
  );
}
